window.app = window.app || {};

window.app.imagesCarousel = {
  el: {
    carousel: document.querySelector('.mt-images-carousel .swiper'),
    blocks: document.querySelectorAll('.mt-images-carousel__block')
  },

  init: function() {
    const _this = this;

    if (_this.el.carousel) {
      _this.slider = new Swiper(_this.el.carousel, {
        slidesPerView: 1.5,
        spaceBetween: 8,
        loop: true,
        direction: 'horizontal',
        freeMode: true,
        allowTouchMove: true,
        speed: 3000,
        a11y: false,
        grabCursor: true,
        watchSlidesProgress: true,
        initialSlide: 4,
        autoplay: {
          delay: 1,
          pauseOnMouseEnter: false,
          disableOnInteraction: false
        },
        breakpoints: {
          460: {
            slidesPerView: 3
          },
          600: {
            slidesPerView: 4,
            spaceBetween: 16
          },
          1800: {
            slidesPerView: 4,
            spaceBetween: 16,
            speed: 8000
          }
        }
      });
    }
  }
}
window.app.imagesCarousel.init();